import styled from "styled-components";

export const StyledDownloadPage = styled.main`
  box-sizing: border-box;
  min-height: calc(100vh - 100px);
  padding: 48px 24px 64px;
  background: #f5f7fb;

  @media (max-width: 600px) {
    padding: 28px 16px 40px;
  }
`;

export const DownloadContent = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
`;

export const DownloadHeader = styled.header`
  margin-bottom: 30px;
`;

export const Eyebrow = styled.div`
  margin-bottom: 8px;
  color: #5368a8;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const PageTitle = styled.h1`
  margin: 0;
  color: #202b45;
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 700;
  letter-spacing: -0.035em;
`;

export const PageDescription = styled.p`
  max-width: 660px;
  margin: 10px 0 0;
  color: #667085;
  font-size: 15px;
  line-height: 1.6;
`;

export const ReleaseCount = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 20px;
  padding: 7px 12px;
  border: 1px solid #e1e6f0;
  border-radius: 999px;
  background: #fff;
  color: #4b5872;
  font-size: 13px;
  font-weight: 600;
`;

export const ReleaseList = styled.div`
  display: grid;
  gap: 16px;
`;

export const ReleaseCard = styled.section`
  overflow: hidden;
  border: 1px solid #e5e9f1;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(30, 48, 86, 0.045);
  transition:
    border-color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;

  &:hover {
    transform: translateY(-1px);
    border-color: #d3dbed;
    box-shadow: 0 8px 24px rgba(30, 48, 86, 0.08);
  }
`;

export const ReleaseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px;
  border-bottom: 1px solid #edf0f5;

  @media (max-width: 600px) {
    align-items: flex-start;
    padding: 16px;
  }
`;

export const ReleaseVersion = styled.h2`
  margin: 0;
  color: #26334f;
  font-size: 18px;
  font-weight: 650;
`;

export const ReleaseType = styled.span`
  flex: 0 0 auto;
  padding: 5px 9px;
  border-radius: 6px;
  background: #eef2ff;
  color: #4e62a4;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const FileList = styled.div`
  display: grid;
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  padding: 16px 22px;

  & + & {
    border-top: 1px solid #f0f2f6;
  }

  @media (max-width: 600px) {
    flex-wrap: wrap;
    padding: 16px;
  }
`;

export const FileIcon = styled.div`
  display: grid;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 10px;
  background: #f1f4fa;
  color: #65759d;
  font-size: 18px;
`;

export const FileInfo = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const FileName = styled.div`
  overflow: hidden;
  color: #303b54;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileDescription = styled.div`
  margin-top: 4px;
  color: #8a93a5;
  font-size: 12px;
`;

export const DownloadButton = styled.div`
  flex: 0 0 auto;

  .e-progress-btn {
    min-width: 112px;
    border-radius: 7px;
    font-weight: 600;
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-left: 56px;

    .e-progress-btn {
      width: 100%;
    }
  }
`;

export const EmptyState = styled.div`
  padding: 40px 24px;
  border: 1px dashed #d7deeb;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.7);
  color: #737f95;
  text-align: center;
`;
